export const USER_MANAGEMENT_MODULE_KEY = 'user-management' as const

/**
 * Angular `AuthService.setSessionValue` / `getSessionValue` — `user-management-list` merges this into
 * filter params on load (`triggerFilter` / `setDefaultRequestParam`).
 */
export const USERLIST_FILTER_SESSION_KEY = "userlist_filter"
